var _style, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoodmeshPearCircleGreengrad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.996,
    y1: 1071.5762,
    x2: 74.004,
    y2: 988.4238,
    gradientTransform: "matrix(1 0 0 1 0 -980)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD24A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1158,
    style: {
      stopColor: "#91C248"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3314,
    style: {
      stopColor: "#5FA844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5348,
    style: {
      stopColor: "#379341"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7201,
    style: {
      stopColor: "#1A843F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8812,
    style: {
      stopColor: "#097B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03783D"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 48
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M48.2,21.5c-1-1.7-2.6-2.5-4.3-2.3c-0.6,0.1-2.1,0.3-2.5,1.7c-0.3,1.1,0.2,2.2,1.4,2.7h0.1 c0.8,0.4,1.6,0.1,2-0.1l0,0c0.7,0.7,1,1.6,1.1,2.9c0,0.1,0,0.2,0,0.4c0,0.7,0,1.7,0.8,2.5c0.5,0.5,1,0.6,1.3,0.6 c0.2,0,0.3,0,0.5-0.1c0.7-0.2,1.1-0.9,1.2-1.9C50,25.5,49.5,23.3,48.2,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M57.3,49.7L57.3,49.7c0.8-1.1,2-0.9,2.9-0.4c0.1,0,0.1,0.1,0.2,0.1c0.4,0.2,0.9,0.4,1.4,0.7V50 c0.1-0.8,0.1-1.6,0.3-2.4c0.1-0.6,0.3-1.5,1.1-1.9c0.5-0.3,1-0.3,1.6-0.1c0.1,0,0.1,0,0.2,0.1l0.1,0.1c0.6,0.6,0.7,1.3,0.7,2 c0,0.8,0,1.5,0,2.3c0,0.7,0,1.5,0,2.2c0,1.2-0.5,1.8-0.9,2.1c-0.3,0.3-0.9,0.5-1.7,0.2c-1.5-0.6-2.9-1.3-4.4-2l-0.1-0.1 c-0.3-0.1-0.5-0.3-0.8-0.4C56.7,51.6,56.8,50.5,57.3,49.7z M51.6,38c-0.5-0.4-1.1-0.7-1.7-0.9c-1.7-0.6-3.6-0.2-4.6,1.2 c-0.8,1-1.6,2.7-2.5,3.8c-0.7,1-2.5,3.2-3.8,2s-0.2-3.1,0.4-4.4c1.3-2.7,3.4-6.1,6.4-7.4c2-0.9,4.3-0.8,6.2,0.1 c2.4,1.1,4.2,3,5.6,5.1c1.5,2.1,3.3,4.7,3.3,7.4c0,0.6-0.1,1.1-0.6,1.5c-0.3,0.2-0.7,0.3-1.1,0.3c-1.4,0-2.2-1.1-2.8-2.1 C55.2,42.5,53.8,39.7,51.6,38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.9,47.6c0,0.7,0.1,1.5,0.1,2.2c0.1,0.7,0.1,1.4,0.1,2.1c0.1,1.1-0.4,2.6-1.6,2.7 c-1.6,0.3-2.1-1.5-2.3-2.7c0-0.2-0.1-0.6-0.1-0.8c-0.3,0-0.8,0.3-1.6,0.7c-0.2,0.1-0.5,0.3-0.6,0.4c-0.4,0.2-1.5,0.7-2.3-0.4 c-0.3-0.4-0.4-0.8-0.4-1.3c0.1-0.5,0.4-1,0.8-1.3c1.6-1.2,3.2-2.4,5-3.3c0.8-0.5,1.5-0.4,1.8-0.2C39.4,46,39.8,46.5,39.9,47.6z  M34.6,59c0,0.1-0.1,0.3-0.1,0.4c-0.5,1.5-0.9,2.9-0.9,4.5c0,1.7,0.4,3.5,1.2,5c1.4,2.7,3.9,4.9,7,5.8c0.9,0.3,2,0.6,2.3,1.5 c0.2,0.7-0.1,1.4-0.7,1.9c-0.6,0.4-1.3,0.6-2,0.7c-2.5,0.3-5-0.4-7.2-1.7C32,75.8,30.3,74,29,71.8c-1.1-1.9-2-3.9-2-6.1 c0-2,0.7-3.9,1.8-5.7c1.1-1.9,2.6-3.9,4.2-5.4c1.4-1.2,2.9,0.1,2.7,1.6C35.7,57,35,58.2,34.6,59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M53.4,73.2C53.2,74.5,52.2,75,51,75c-0.1,0-0.1,0-0.2,0c-0.5,0-1,0.1-1.5,0.1v0.1c0.3,0.7,0.6,1.4,0.9,2.2 c0.2,0.6,0.4,1.4,0,2.2c-0.3,0.5-0.7,0.8-1.3,0.8c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.2,0c-0.8-0.2-1.2-0.8-1.6-1.5 c-0.3-0.7-0.7-1.4-1.1-2c-0.3-0.6-0.7-1.3-1.1-2c-0.5-1.1-0.4-1.8-0.2-2.3c0.2-0.4,0.6-0.9,1.4-1c1.6-0.2,3.2-0.3,4.8-0.4H51 c0.3,0,0.6,0,0.9,0C53,71.2,53.5,72.2,53.4,73.2L53.4,73.2z M71.1,64.9c-0.1-2-0.8-3.9-1.5-5.7c-0.5-1.4-1.3-2.8-2.5-3.6 c-0.5-0.4-1.2-0.5-1.8-0.1c-0.7,0.4-0.9,1.3-0.7,2c0.4,2.4,1.2,5.1,0.7,7.5c-0.8,3.1-2.7,6-5.1,8c-1.8,1.5-3.6,2.3-6,2.4 c-0.8,0-2.3,0.1-2.4,1.2c0,0.5,0.3,0.9,0.7,1.2c1.8,1.5,4.5,1.3,6.6,0.9c3.5-0.6,6.1-1.9,8.3-4.5c1.7-1.9,2.9-4.1,3.3-6.6 C71.1,66.6,71.1,65.7,71.1,64.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M51.3,28.2C51.3,28.1,51.3,28.1,51.3,28.2c1.3-2,2.7-3.4,4.4-4.6c1.4-1,3-1.5,4.5-2l0.3-0.1 c0.3-0.1,1.1-0.4,1.3,0.3c0.3,0.7-0.5,1-0.7,1.1H61c-2.4,1-4.2,2.3-6,3.6l-0.2,0.2c-0.6,0.5-1.2,1.1-1.7,1.7 c-0.3,0.3-0.5,0.6-0.8,0.9s-0.4,0.7-0.8,0.3c-0.1-0.1-0.3-0.3-0.3-0.4C50.9,28.9,51.1,28.5,51.3,28.2z M51.7,25.5 c0.2,0,0.4-0.1,0.5-0.3c0.5-0.5,0.9-1.1,1.4-1.6c0.6-0.5,1.2-0.9,1.8-1.2c1.6-0.9,3.2-1.5,5-2c1.1-0.4,2.1-0.8,3.1-1.2 c1-0.4,2-0.8,2.8-1.4c0.1-0.1,0.2-0.1,0.2-0.2c0.2,1.5,0.2,2.9-0.9,4.2c-1,1.2-2.3,2.1-3.6,2.7c-1.5,0.8-3,1.3-4.6,2 c-0.6,0.3-1.2,0.5-1.7,0.8c-0.5,0.2-1.1,0.4-1.4,0.8c-0.5,0.4,0,1,0.3,1.4c0.5,0.6,1.1,0.7,1.9,0.4c1.7-0.7,3.3-1.2,5.1-1.7 c2.1-0.6,4.2-1.4,6-2.8c1.6-1.4,2-3.2,2.1-5.2c0-0.3,0-0.5,0-0.8c0.1-1.4-1-5.3-2.8-5.5c-0.9-0.1-1.4,1.1-2.1,1.5 c-1.1,0.7-2.4,1.2-3.6,1.8c-2.8,1.3-6.1,2.3-8.3,4.3c-0.6,0.5-1.2,1.2-1.6,2c-0.3,0.6-0.3,1.4,0.1,2 C51.5,25.4,51.5,25.5,51.7,25.5L51.7,25.5z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodmeshPearCircleGreengrad);
export default __webpack_public_path__ + "static/media/foodmesh-pear-circle-greengrad.3c500ed6.svg";
export { ForwardRef as ReactComponent };